import { RollbackOutlined } from '@ant-design/icons';
import { useLocation } from '@umijs/max';
import React from 'react';
import {
  CUSTOMER_LIST_PATH,
  extractCustomerUuidFromPathname,
  isCustomerWorkspacePath,
} from '@/modules/customer/customerWorkspaceModel';
import { getCrmCustomer } from '@/services/crm';
import { navigateWithBrowserGestureSupport } from '@/utils/linkNavigation';

const useResolvedCustomerWorkspace = () => {
  const location = useLocation();
  const [resolvedCustomerName, setResolvedCustomerName] =
    React.useState<string>('');
  const customerUuid = React.useMemo(
    () => extractCustomerUuidFromPathname(location.pathname),
    [location.pathname],
  );

  React.useEffect(() => {
    if (!customerUuid) {
      setResolvedCustomerName('');
      return;
    }

    let cancelled = false;
    setResolvedCustomerName('');

    getCrmCustomer(customerUuid)
      .then((customer) => {
        if (!cancelled) {
          setResolvedCustomerName(customer.name?.trim() || '');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setResolvedCustomerName('');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [customerUuid]);

  const customerName = React.useMemo(() => {
    if (!customerUuid) {
      return '';
    }
    return resolvedCustomerName || `客户 ${customerUuid.slice(0, 8)}`;
  }, [customerUuid, resolvedCustomerName]);

  return {
    customerUuid,
    customerName: customerName || '客户空间',
  };
};

const CustomerWorkspaceHeaderBanner: React.FC = () => {
  const location = useLocation();
  const { customerUuid, customerName } = useResolvedCustomerWorkspace();

  if (!customerUuid || !isCustomerWorkspacePath(location.pathname)) {
    return null;
  }

  return (
    <div className="app-header-detail-banner-shell">
      <fieldset className="app-header-detail-banner" aria-label="当前客户">
        <a
          href={CUSTOMER_LIST_PATH}
          className="app-header-detail-back-btn"
          onClick={(event) =>
            navigateWithBrowserGestureSupport(event, CUSTOMER_LIST_PATH)
          }
        >
          <RollbackOutlined />
          <span className="app-header-detail-back-text">返回</span>
        </a>
        <span className="app-header-detail-banner-name" title={customerName}>
          {customerName}
        </span>
      </fieldset>
    </div>
  );
};

export default CustomerWorkspaceHeaderBanner;
